import React, { useCallback, useEffect, useState } from "react";
import DownloadDrop from "../../DeskDropdowns/DownloadDrop";
import FilterAssetDrop from "../../DeskDropdowns/FilterAssetDrop";
import QtyDrop from "../../DeskDropdowns/QtyDrop";
import SortDrop from "../../DeskDropdowns/SortDrop";
import HoldingsTable from "./HoldingsTable";
import { useDispatch, useSelector } from "react-redux";
import di from "../../di/servicelocator";
import "../../../../../stylesheets/components/Reports/HoldingReports/HoldingReports.scss";
import debounce from "@frameworks/web/utils/debounce";
import FilterLabels from "../../../../../components/generic/FilterLabels/FilterLabels";
import SortLabels from "@frameworks/web/components/generic/SortLabels/SortLabel";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import { ESortOrder } from "@domains/utils/sort";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { usePageVisibility } from "../../../../../components/generic/customHooks/usePageVisibility";
import { retrieveExtPlatAccDataThunks } from "@frameworks/web/redux/reducers/RetrieveExtPlatAccData";
import { accountDetails } from "@di";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { FilterTabEnum, tabWithAssetCategory, } from "@frameworks/web/components/Reports/CommonComponent/constant";
import { AssetCategory, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import HoldingSummary from "@frameworks/web/components/Reports/HoldingReports/Desktop/HoldingReports/HoldingSummary";
import _ from "underscore";
import { useNavigate } from "react-router-dom";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
const HoldingReport = (props) => {
    var _a, _b, _c;
    const wrapperRef = React.useRef(null);
    const sortRef = React.useRef(null);
    const downloadRef = React.useRef(null);
    const qtyRef = React.useRef(null);
    const prodAssetFilterRef = React.useRef(null);
    const isVisible = usePageVisibility();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const edelweissProductCode = getQueryParameterName("edelweissProductCode");
    const [dataT, changeTableData] = React.useState("AllQty");
    const [selectedSortLable, setSelectedSortLable] = React.useState("");
    const [showSearch, setShowSearch] = React.useState(false);
    const [filterOpen, setFilterOpen] = React.useState(true);
    const [showTableDropdown, setshowTableDropdown] = React.useState(false);
    const [showSortDropdown, setshowSortDropdown] = React.useState(false);
    const [showQtyDropdown, setshowQtyDropdown] = React.useState(false);
    const [showFilterAssetDropdown, setshowFilterAssetDropdown] = React.useState(false);
    const [showOptions, setShowOptions] = React.useState(false);
    const [sortByFilters, setSortByFilters] = React.useState([]);
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const [filterBubbles, setFilterBubbles] = useState([]);
    const [isInsuranceTabOnly, setIsInsuranceTabOnly] = useState(false);
    /***************************Redux state******************************** */
    const { simpleFilter, assetFilter, productAssetFilter } = useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.FilterData; }, _.isEqual);
    const loader = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.loader; });
    const [searchVal, setSearchVal] = React.useState(useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SearchData; }));
    const { HoldingDataFlags: isOmneOnly, HoldingDetails } = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data; });
    const toggleTable = useSelector((state) => state.holdingReport.smtf);
    const isSummarize = useSelector((state) => state.holdingReport.data.IsSummarize, _.isEqual);
    const holdingError = useSelector((state) => state.holdingReport.errorData);
    const emptyValidation = useSelector((state) => state.holdingReport.emptyValidation);
    const selectedProduct = useSelector((state) => state.holdingReport.prodDropDown);
    const finalSortList = useSelector((state) => state.holdingReport.data.SortData);
    const disableOperations = (HoldingDetails === null || HoldingDetails === void 0 ? void 0 : HoldingDetails.length) === 0;
    //all are no data conditions
    // holdingError?.isOpen ||
    // emptyValidation.icon ===
    //   EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS].icon ||
    // props.loader ||
    // (productAssetFilterSelected &&
    //   emptyValidation.icon === EmptyValidation[EmptyIcon.FILTER].icon) ||
    // (isAssetFilterSelected() &&
    //   emptyValidation.icon === EmptyValidation[EmptyIcon.FILTER].icon);
    /********************************Functions************************************ */
    const removeFilter = async (title) => {
        di.holdingReport.removeFilters(title);
    };
    let handleSearchInput = (e) => {
        var _a;
        setSearchVal((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
        debounce(async function () {
            di.holdingReport.getSearchHoldingReportData(e.target.value);
        }, 300)();
    };
    const handleScroll = () => {
        const position = window.pageYOffset;
        debounce(() => {
            setScrollPosition(position);
            di.holdingReport.scrollState = position;
        }, 300)();
    };
    const resetSearch = async () => {
        setSearchVal("");
        di.holdingReport.getSearchHoldingReportData("");
    };
    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target))
            setshowFilterAssetDropdown(false);
        if (prodAssetFilterRef.current &&
            !prodAssetFilterRef.current.contains(event.target))
            setShowOptions(false);
    }, []);
    const qts = [
        { title: "All Quantity", value: "AllQty" },
        { title: "Tradeable Quantity", value: "tradableQty" },
    ];
    const clearAllFilter = async () => {
        if (props.keyTab === FilterTabEnum.ALL) {
            sessionStorage.removeItem("assetFilter");
            di.holdingReport.clearAllFilters();
        }
        else
            di.holdingReport.clearSingleFilter("simpleFilter");
    };
    const resetSort = () => {
        di.holdingReport.getSortedHoldingReportData({
            displayName: "Alphabetical",
            order: ESortOrder.DESC,
            sortName: "displayName",
        }, false);
        //above will update in finalSortList through  usecase
        setshowSortDropdown(false);
    };
    const clearAllLabels = () => {
        resetSort();
        clearAllFilter();
    };
    const closeSearch = () => {
        if (!searchVal)
            setShowSearch(false);
    };
    const getPledgeLink = (loader) => {
        if (loader !== undefined && loader)
            return "";
        else {
            props.setLoader(loader);
            window.open(di.holdingReport.edisOrPledgeUrl, "_blank");
        }
    };
    const getAccountDataFromExPlat = async () => {
        localStorage.removeItem("isin");
        localStorage.removeItem("assetType");
        localStorage.removeItem("displayName");
        localStorage.removeItem("tradingSymbol");
        localStorage.removeItem("action");
        localStorage.removeItem("description");
        localStorage.removeItem("orderstatus");
        const loginSource = await accountDetails.getLoginSrc();
        if (loginSource && loginSource === LoginSource.TX3) {
            props.setLoader(true);
            dispatch(retrieveExtPlatAccDataThunks(getPledgeLink));
        }
        else {
            getPledgeLink(false);
        }
    };
    const GTMTagHandle = () => {
        if (props.isMyaccount && !isInsuranceTabOnly) {
            getAccountDataFromExPlat();
            GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.TapPledge, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, di.holdingReport.isNonPoaClient
                ? ReportsGTMConstants.TapAuth
                : ReportsGTMConstants.TapPledge));
        }
    };
    const selectAssetProduct = (selected) => {
        setShowOptions(false);
        if (edelweissProductCode)
            navigate("/reports?reportName=Holding");
        if (selected.display !== "All") {
            di.holdingReport.onProductChange(selected);
        }
        else {
            di.holdingReport.onAssetChange(tabWithAssetCategory[props === null || props === void 0 ? void 0 : props.keyTab]);
        }
        di.holdingReport.saveProdAssetDropDown(selected, props.keyTab);
        if (props.keyTab === "Other")
            GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.PNL, ReportsGTMConstants.NewReports, `${ReportsGTMConstants.Others} | ${selected}`));
    };
    /*****************************UseEffects*********************************** */
    useEffect(() => {
        let selectedSort = finalSortList.find((sort) => sort.order !== ESortOrder.UNCHANGED);
        if ((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.displayName) == "Alphabetical" &&
            (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.order) === -1) {
            //becoz  Alphabetical + ascending is default sort  no need to display
            setSelectedSortLable("");
        }
        else
            setSelectedSortLable(selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.displayName);
    }, [finalSortList]);
    useEffect(() => {
        let bubbles = [];
        let selectedAsset = [];
        if ((props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.ALL) {
            // for other tabs asset filter bubbles should not be  shown,  as user  is already in that asset
            assetFilter.filters.map((asset) => {
                if (asset.selected) {
                    bubbles.push(asset.title);
                    selectedAsset.push(asset.key);
                }
            });
        }
        simpleFilter.filters.map((filterFlag) => {
            if (filterFlag.selected) {
                bubbles.push(filterFlag.title);
            }
        });
        setFilterBubbles(bubbles);
        // check whether user select only insurance  asset
        let insuranceTab = (props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.INSURANCE ||
            (selectedAsset.length === 1 &&
                selectedAsset[0] === AssetCategory.LifeInsurance);
        if (insuranceTab) {
            //not applicable for only insurance asset, so we have to reset and disable
            di.holdingReport.toggleQtyBreakDown(false);
            changeTableData("AllQty");
        }
        setIsInsuranceTabOnly(insuranceTab);
    }, [
        JSON.stringify(simpleFilter.filters),
        JSON.stringify(assetFilter.filters),
    ]);
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef, prodAssetFilterRef]);
    useEffect(() => {
        function handleSortOutside(event) {
            if (sortRef.current && !sortRef.current.contains(event.target))
                setshowSortDropdown(false);
            if (downloadRef.current && !downloadRef.current.contains(event.target))
                setshowTableDropdown(false);
            if (qtyRef.current && !qtyRef.current.contains(event.target))
                setshowQtyDropdown(false);
        }
        document.addEventListener("mousedown", handleSortOutside);
        return () => {
            document.removeEventListener("mousedown", handleSortOutside);
        };
    }, [sortRef, downloadRef, qtyRef]);
    useEffect(() => {
        di.holdingReport.fetchEdisOrEpledgeUrl();
        di.holdingReport.getDefaultEmail();
        window.scrollTo(0, di.holdingReport.scrollState);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        props.assetFilter.showList && (React.createElement("div", null,
            React.createElement("div", { ref: prodAssetFilterRef, className: " d-inline-block posrel", style: { width: "auto" } },
                React.createElement("div", { onClick: () => setShowOptions((prevState) => !prevState), className: "selected_option" },
                    selectedProduct && React.createElement("span", null, selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.display),
                    React.createElement("span", { className: "edel-icon-arrow-down" })),
                showOptions && (React.createElement("div", { className: "select_options" }, props.assetFilter.assetProductList.map((x, i) => {
                    if (selectedProduct === x)
                        return;
                    return (React.createElement("span", { key: i, onClick: () => selectAssetProduct(x) }, x.display));
                })))))),
        React.createElement("div", { className: "summary-row" },
            React.createElement("div", { className: "date-text" },
                React.createElement("span", { className: `date-left text-muted ${scrollPosition > 20 ? "dock-date" : ""}` }, (_c = (_b = (_a = di.holdingReport) === null || _a === void 0 ? void 0 : _a.holdingReportData) === null || _b === void 0 ? void 0 : _b.HoldingSummary) === null || _c === void 0 ? void 0 : _c.date)),
            React.createElement("div", null,
                React.createElement(HoldingSummary, { scrollPosition: scrollPosition, keyTab: isInsuranceTabOnly ? FilterTabEnum.INSURANCE : props.keyTab }))),
        React.createElement("div", { className: "wrapper-fil reports_old_theme", id: "search-filter" },
            React.createElement("div", { className: "d-flex align-items-center " },
                React.createElement("div", { className: "fil-left col-md-5 d-flex" },
                    React.createElement("div", { className: "summarize" },
                        React.createElement("label", { className: `custom-control border-switch ${disableOperations && "opacity-25"}` },
                            React.createElement("input", { type: "checkbox", className: "border-switch-control-input border-switch-control-input-new", checked: isSummarize, disabled: disableOperations, onChange: (e) => {
                                    var _a;
                                    di.holdingReport.getSummarizeHoldingReportData((_a = e.target) === null || _a === void 0 ? void 0 : _a.checked);
                                } }),
                            React.createElement("span", { className: "border-switch-control-indicator" }),
                            React.createElement("span", { className: "teleport-switch-control-description" }, "Summarize Values"))),
                    React.createElement("div", { className: "quantity ps-4" },
                        React.createElement("div", { className: "d-flex align-items-center" },
                            React.createElement("div", { ref: qtyRef },
                                React.createElement("button", { className: `btn-select-qty btn-select-qty-new ${!props.isMyaccount ||
                                        disableOperations ||
                                        isInsuranceTabOnly
                                        ? "opacity-25 cursor_not_allowed"
                                        : "hand_cursor"}`, onClick: () => setshowQtyDropdown(!showQtyDropdown), disabled: disableOperations ||
                                        !props.isMyaccount ||
                                        isInsuranceTabOnly },
                                    dataT == "AllQty" ? "All Quantity" : "Tradable Quantity",
                                    React.createElement("i", { className: "edel-icon-arrow-down" })),
                                showQtyDropdown && (React.createElement("div", { style: { position: "relative" } },
                                    React.createElement(QtyDrop, { qts: qts, changeTableData: changeTableData, setshowQtyDropdown: setshowQtyDropdown })))))),
                    React.createElement("div", { className: `taptopledge ${!props.isMyaccount || isInsuranceTabOnly
                            ? "opacity-25 cursor_not_allowed"
                            : "hand_cursor"}` },
                        React.createElement("a", { target: "_blank", onClick: GTMTagHandle },
                            React.createElement("label", { className: "custom-control border-switch txt-secondarynavy" },
                                React.createElement("i", { className: "edel-icon-pledge" }),
                                React.createElement("span", { className: `teleport-switch-control-description ` }, di.holdingReport.isNonPoaClient
                                    ? "Tap to Authorize"
                                    : " Tap to Pledge")))),
                    React.createElement("div", { className: "mx-3" },
                        React.createElement("label", { className: `custom-control border-switch ${disableOperations || !props.isMyaccount || isInsuranceTabOnly
                                ? "opacity-50 cursor_not_allowed"
                                : "hand_cursor"}` },
                            React.createElement("input", { type: "checkbox", className: `border-switch-control-input border-switch-control-input-new `, onChange: (e) => {
                                    di.holdingReport.toggleQtyBreakDown(e.currentTarget.checked);
                                }, defaultChecked: toggleTable, checked: toggleTable, disabled: disableOperations ||
                                    !props.isMyaccount ||
                                    isInsuranceTabOnly }),
                            React.createElement("span", { className: `border-switch-control-indicator ${disableOperations ||
                                    !props.isMyaccount ||
                                    isInsuranceTabOnly
                                    ? "opacity-50 cursor_not_allowed"
                                    : "hand_cursor"}` }),
                            React.createElement("span", { className: "teleport-switch-control-description" }, "Show Qty breakdown")))),
                React.createElement("div", { className: "col-md-7 d-flex align-items-center justify-content-end holding-position-filter" },
                    React.createElement("div", { className: "downloads", ref: downloadRef },
                        React.createElement("button", { className: "btn btn-outline-primary downloads  downloads-new justify-content-between", onClick: () => setshowTableDropdown(!showTableDropdown), disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) || props.loader },
                            React.createElement("i", { className: "edel-icon-download " }),
                            "Download",
                            React.createElement("i", { className: "edel-icon-arrow-down" })),
                        showTableDropdown && (React.createElement(DownloadDrop, { setshowTableDropdown: setshowTableDropdown, accCode: props.accCode, isMyaccount: props.isMyaccount }))),
                    React.createElement("div", { className: `searchbar-c ` },
                        React.createElement("div", { className: "input-group" },
                            React.createElement("div", { className: "input-group-prepend" },
                                React.createElement("label", { htmlFor: "focus-input" },
                                    React.createElement("i", { className: `edel-icon-search input-group-text  ${showSearch ? " ser-icon bg-white " : ""}`, onClick: () => {
                                            if (!(holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) && !props.loader)
                                                setShowSearch(true);
                                        } }))),
                            React.createElement("input", { id: "focus-input", type: "search", className: `form-control ${showSearch ? "input-ex bg-white " : ""}`, placeholder: "Search", "aria-label": "search", "aria-describedby": "basic-addon1", name: "search", onChange: handleSearchInput, onFocus: () => setShowSearch(true), value: searchVal, onBlur: closeSearch, autoComplete: "off", disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) || props.loader }),
                            showSearch && (React.createElement("div", { className: "input-group-prepend" },
                                React.createElement("label", { htmlFor: "focus-input" },
                                    React.createElement("i", { className: `edel-icon-close input-group-text ${showSearch ? "ex-close bg-white " : ""}`, onClick: resetSearch })))))),
                    React.createElement("div", { className: "sort  position-relative" },
                        React.createElement("div", { ref: sortRef },
                            React.createElement("button", { className: showSortDropdown
                                    ? "btn showblue btn-outline-primary sorting"
                                    : "btn btn-outline-primary sorting", onClick: () => {
                                    setshowSortDropdown(!showSortDropdown);
                                    window.scrollTo(0, 130);
                                }, disabled: disableOperations },
                                React.createElement("i", { className: "edel-icon-sort sort-filter-icon" }, selectedSortLable && (React.createElement("span", { className: "sort-filter-selected" })))),
                            showSortDropdown && (React.createElement("div", { className: "showSortDropdown" },
                                React.createElement(SortDrop, { setshowSortDropdown: setshowSortDropdown, sortByFilters: finalSortList, themeClass: "sort-drop-light-blue-theme" }))))),
                    React.createElement("div", { className: "filter holding-filter-desk " },
                        React.createElement("div", { ref: wrapperRef, style: { position: "relative" } },
                            React.createElement("button", { className: showFilterAssetDropdown
                                    ? "btn showblue btn-outline-primary filter"
                                    : "btn btn-outline-primary filter", onClick: () => {
                                    setshowFilterAssetDropdown(!showFilterAssetDropdown);
                                    window.scrollTo(0, 130);
                                }, disabled: (holdingError === null || holdingError === void 0 ? void 0 : holdingError.isOpen) ||
                                    emptyValidation.icon ===
                                        EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS]
                                            .icon ||
                                    props.loader ||
                                    (props === null || props === void 0 ? void 0 : props.keyTab) === FilterTabEnum.INSURANCE },
                                React.createElement("i", { className: "edel-icon-filter filter-icon" }, filterBubbles.length > 0 && (React.createElement("span", { className: "filter-selected" })))),
                            showFilterAssetDropdown && (React.createElement(FilterAssetDrop, { setshowFilterAssetDropdown: setshowFilterAssetDropdown, filterData: {
                                    simpleFilter,
                                    assetFilter,
                                    productAssetFilter,
                                }, filterOpen: filterOpen, setFilterOpen: setFilterOpen, showAsset: props.keyTab === FilterTabEnum.ALL, keyTab: props.keyTab, themeClass: "filterasset-drop-light-blue-theme" }))))))),
        (filterBubbles.length > 0 || selectedSortLable) && (React.createElement("div", { className: `filters-tag
            ${DeviceContext().isDesktop ? "filter-s filters-dock" : ""}` },
            selectedSortLable && (React.createElement(SortLabels, { LabelText: selectedSortLable, closeBtn: true })),
            filterBubbles.map((title) => (React.createElement(FilterLabels, { LabelText: title, closeBtn: true, FilterAction: removeFilter }))),
            React.createElement(FilterLabels, { LabelText: "Clear All", closeBtn: false, FilterAction: clearAllLabels }))),
        React.createElement("div", { className: "holdings-table-content-wrapper positionSticky" },
            React.createElement(HoldingsTable, { getVal: dataT, setOpenDrawer: props.setOpenDrawer, openDrawer: props.openDrawer, searchVal: searchVal, shimmer: loader, setShimmer: props.setLoader, sortSelected: !!selectedSortLable, isSimpleFilterSelected: filterBubbles.length > 0, toggleTable: toggleTable, setDefaultSideBarTab: props.setDefaultSideBarTab, setAssetType: props.setAssetType, setHoldingStockDetail: props.setHoldingStockDetail, keyTab: isInsuranceTabOnly ? FilterTabEnum.INSURANCE : props.keyTab, accCode: props.accCode }))));
};
export default HoldingReport;
